<template>
    <div>
        <div class="card-body">
            <el-form label-position="left" label-width="80px">
                <el-row :span="20">
                    <el-col :span="20">
                        <el-form-item label="解决方案:">
                            <el-select v-model="$parentInfo.studentPeriod.activePeriod.status" placeholder="请选择">
                                <el-option
                                        v-for="item in $parentInfo.studentPeriod.activePeriod.options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="请假类型:" v-if="$parentInfo.studentPeriod.activePeriod.status=='leaving'">
                            <el-select
                                    v-model="use_status_type"
                                    placeholder="请选择">
                                <el-option
                                        v-for="item in status_types"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer" align="right">
                <el-button type="primary" size="small" @click="changeClassesPlan('调课课表')"
                           v-if="$parentInfo.studentPeriod.activePeriod.status==='switching'">调课课表
                </el-button>
                <el-button type="primary" size="small" @click="changeClassesPlan('补课课表')"
                           v-else-if="$parentInfo.studentPeriod.activePeriod.status==='tutorship'">补课课表
                </el-button>
                <el-button type="primary" size="small" @click="handleAbsentClassInActive()"
                           :loading="$parentInfo.studentPeriod.activePeriod.button_loading" v-else>保存
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                options: [

                ],
                status_types:[
                    {
                        value:1,
                        label:'个人原因'
                    },
                    {
                        value:2,
                        label:'病假'
                    },
                    {
                        value:3,
                        label:'个人社会实践'
                    },
                    {
                        value:4,
                        label:'学校集体活动'
                    },
                ],
                use_status_type:''
            };
        },
        props: {
            classPlanStudent_id: {
                default: 0,
            },
            student_id: {
                default: 0,
            },
            class_name: {
                default: '',
            },
            status_type:{}
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
        },
        methods: {
            handleAbsentClassInActive() {
                this.$parentInfo.studentPeriod.activePeriod.button_loading = true;
                if(this.$parentInfo.studentPeriod.activePeriod.status=='refund'){
                    this.$wApi.send(this.$parentInfo.path, 'leavingPeriod', {
                        'classPlanStudent_id': this.classPlanStudent_id,
                        'status': this.$parentInfo.studentPeriod.activePeriod.status,
                        'student_id': this.$parentInfo.student_id,
                    });
                }else{
                    this.$wApi.send(this.$parentInfo.path, 'activeAndAbsentClass', {
                        'classPlanStudent_id': this.classPlanStudent_id,
                        'reason': this.$parentInfo.studentPeriod.activePeriod.reason,
                        'status': this.$parentInfo.studentPeriod.activePeriod.status,
                        'student_id': this.$parentInfo.student_id,
                        'use_status_type':this.use_status_type
                    });
                }

            },
            changeClassesPlan(title) {
                this.$emit('hideModel');
                this.$Win.openModal('Dialog_ChangeClassPlan',1000,900, title, {
                    'classPlanStudent_id': this.classPlanStudent_id,
                    'reason': this.$parentInfo.studentPeriod.activePeriod.reason,
                    'status': this.$parentInfo.studentPeriod.activePeriod.status,
                    'student_id': this.student_id,
                    'class_name': this.class_name
                }, true);

            },
        }
    };
</script>

<style scoped>

</style>
